const SCOPE = 'platform-group'

// Stored in sessionStorage (not localStorage) — cleared on the next page load after logout
export const JUST_LOGGED_OUT_KEY = `${SCOPE}/irwin/just-logged-out`
// Set when the session expires (e.g. 401 from API), cleared after the interstitial is shown
export const JUST_SESSION_EXPIRED_KEY = `${SCOPE}/irwin/just-session-expired`
// Set by FactsetAuthCallback when signinRedirectCallback fails — used to break the signinRedirect loop
export const OIDC_CALLBACK_ERROR_KEY = `${SCOPE}/irwin/oidc-callback-error`
